import { render, staticRenderFns } from "./AddCostTemplate.vue?vue&type=template&id=b22b84b4&scoped=true"
import script from "./AddCostTemplate.vue?vue&type=script&lang=js"
export * from "./AddCostTemplate.vue?vue&type=script&lang=js"
import style0 from "@/assets/public.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./AddCostTemplate.vue?vue&type=style&index=1&id=b22b84b4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b22b84b4",
  null
  
)

export default component.exports